// extracted by mini-css-extract-plugin
module.exports = {"root":"Label_root__0wSkS","hasError":"Label_hasError__lT3WB","isDisabled":"Label_isDisabled__c1KN2","requiredIndicator":"Label_requiredIndicator___vL3c"};